export const weatherDescriptions = {
  'clear sky': 'שמים בהירים',
  'few clouds': 'מעט עננים',
  'scattered clouds': 'עננים מפוזרים',
  'broken clouds': 'עננים שבורים',
  'shower rain': 'גשם מקומי',
  'rain': 'גשם',
  'thunderstorm': 'סערת רעמים',
  'snow': 'שלג',
  'mist': 'ערפל',
  'thunderstorm with light rain': 'סופת רעמים עם גשם קל',
  'thunderstorm with rain': 'סופת רעמים עם גשם',
  'thunderstorm with heavy rain': 'סופת רעמים עם גשם כבד',
  'light thunderstorm': 'סופת רעמים קלה',
  'heavy thunderstorm': 'סופת רעמים כבדה',
  'ragged thunderstorm': 'סופת רעמים מרוסקת',
  'thunderstorm with light drizzle': 'סופת רעמים עם טפטוף קל',
  'thunderstorm with drizzle': 'סופת רעמים עם טפטוף',
  'thunderstorm with heavy drizzle': 'סופת רעמים עם טפטוף כבד',
  'light intensity drizzle': 'טפטוף קל',
  'drizzle': 'טפטוף',
  'heavy intensity drizzle': 'טפטוף כבד',
  'light intensity drizzle rain': 'גשם טפטוף קל',
  'drizzle rain': 'גשם טפטוף',
  'heavy intensity drizzle rain': 'גשם טפטוף כבד',
  'shower rain and drizzle': 'גשם מקומי וטפטוף',
  'heavy shower rain and drizzle': 'גשם מקומי כבד וטפטוף',
  'shower drizzle': 'טפטוף מקומי',
  'light rain': 'גשם קל',
  'moderate rain': 'גשם בינוני',
  'heavy intensity rain': 'גשם כבד',
  'very heavy rain': 'גשם כבד מאוד',
  'extreme rain': 'גשם קיצוני',
  'freezing rain': 'גשם קפוא',
  'light intensity shower rain': 'גשם מקומי קל',
  'heavy intensity shower rain': 'גשם מקומי כבד',
  'ragged shower rain': 'גשם מקומי מרוסס',
  'light snow': 'שלג קל',
  'heavy snow': 'שלג כבד',
  'sleet': 'ברד',
  'light shower sleet': 'ברד מקומי קל',
  'shower sleet': 'ברד מקומי',
  'light rain and snow': 'גשם קל ושלג',
  'rain and snow': 'גשם ושלג',
  'light shower snow': 'שלג מקומי קל',
  'shower snow': 'שלג מקומי',
  'heavy shower snow': 'שלג מקומי כבד',
  'smoke': 'עשן',
  'haze': 'ערפל קל',
  'sand/dust whirls': 'סופות חול אבק',
  'fog': 'ערפל כבד',
  'sand': 'חול',
  'dust': 'אבק',
  'volcanic ash': 'אפר וולקני',
  'squalls': 'שקעים',
  'tornado': 'טורנדו',
  'few clouds': 'מעט עננים',
  'scattered clouds':'עננים מפוזרים',
  'broken clouds':'עננים שבורים',
  'overcast clouds': 'עננים מכוסים',
};
